export default __webpack_public_path__ + "static/media/blog-post-02.67c58c60.jpg";